import { Box, Flex, Heading, Text, useTheme } from '@chakra-ui/react'
import React from 'react'
import { Theme } from '../../theme'

const AuthLayout = ({ children }: any) => {
    const theme = useTheme<Theme>()

    const bannerBoxStyle: React.CSSProperties = {
        width: "50%",
        height: "100%",
        position: "fixed",
        right: 0,
        backgroundColor: theme.colors.secondary.main,
    }

    return (
        <Flex sx={{ width: '100%', minHeight: '100vh' }} >
            <Flex
                sx={{
                    width: '100%',
                    height: '100vh',
                    justifyContent: 'center',
                    alignItems: "center",
                }}
            >
                {children}
            </Flex>

            {/* <Flex sx={bannerBoxStyle}>
                <img src="/bg.jpg" alt="bg_image" width="100%" height="100%" style={{ objectFit: "cover" }} />
            </Flex> */}
        </Flex>
    )
}

export default AuthLayout